<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Уведомления клиента</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="kak-popast"
            class="typography__headline2"
          >
            Как попасть
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Давайте настроим уведомления клиентам от&nbsp;вашего бота.</p>

            <p>В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Бот&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>На&nbsp;открывшейся странице выберите в&nbsp;меню слева раздел &laquo;Уведомления клиента&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="tovary"
            class="typography__headline2"
          >
            Товары
          </FaqArticlesBlockHeading>

          <p>В&nbsp;меню слева выберите раздел &laquo;Товары&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Новый заказ&raquo; можно управлять активностью и&nbsp;изменить текст автоматического
              сообщения с&nbsp;кнопкой, отправляющиеся клиенту в&nbsp;боте при оформлении нового заказа.
            </p>

            <p>По-умолчанию уведомление активно.</p>

            <p>После настройки нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-4.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Заказ ожидает оплаты&raquo; можно управлять активностью и&nbsp;изменить текст
              автоматического сообщения с&nbsp;кнопкой, отправляющиеся клиенту в&nbsp;боте при переходе заказа
              в&nbsp;статус &laquo;Ожидает оплаты&raquo;.
            </p>

            <p>По-умолчанию уведомление активно.</p>

            <p>После настройки нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-5.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Заказ в&nbsp;самовывозе&raquo; можно управлять активностью и&nbsp;изменить текст
              автоматического сообщения с&nbsp;кнопкой, отправляющиеся клиенту в&nbsp;боте при переходе заказа
              в&nbsp;статус &laquo;Ожидает самовывоза&raquo;.
            </p>

            <p>По-умолчанию уведомление активно.</p>

            <p>После настройки нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-6.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Заказ в&nbsp;доставке&raquo; можно управлять активностью и&nbsp;изменить текст
              автоматического сообщения с&nbsp;кнопкой, отправляющиеся клиенту в&nbsp;боте при переходе заказа
              в&nbsp;статус &laquo;Доставляется&raquo;.
            </p>

            <p>По-умолчанию уведомление активно.</p>

            <p>После настройки нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-7.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Завершение заказа&raquo; можно управлять активностью и&nbsp;изменить текст автоматического
              сообщения с&nbsp;кнопкой, отправляющиеся клиенту в&nbsp;боте при завершении заказа.
            </p>

            <p>По-умолчанию уведомление не&nbsp;активно.</p>

            <p>После настройки нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-8.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Отмена заказа менеджером&raquo; можно управлять активностью и&nbsp;изменить текст
              автоматического сообщения с&nbsp;кнопкой, отправляющиеся клиенту в&nbsp;боте при отмене заказа менеджером.
            </p>

            <p>По-умолчанию уведомление активно.</p>

            <p>После настройки нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-9.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Возврат заказа&raquo; можно управлять активностью и&nbsp;изменить текст автоматического
              сообщения с&nbsp;кнопкой, отправляющиеся клиенту в&nbsp;боте при при переходе заказа в&nbsp;статус
              &laquo;Возврат&raquo;.
            </p>

            <p>По-умолчанию уведомление активно.</p>

            <p>После настройки нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-10.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="uslugi-s-onlayn-zapisyu"
            class="typography__headline2"
          >
            Услуги с онлайн-записью
          </FaqArticlesBlockHeading>

          <p>В&nbsp;меню слева выберите раздел &laquo;Услуги с&nbsp;онлайн-записью&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-11.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Новая запись&raquo; можно управлять активностью и&nbsp;изменить текст автоматического
              сообщения с&nbsp;кнопкой, отправляющиеся клиенту в&nbsp;боте при оформлении новой записи.
            </p>

            <p>По-умолчанию уведомление активно.</p>

            <p>После настройки нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-12.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Завершение записи&raquo; можно управлять активностью и&nbsp;изменить текст автоматического
              сообщения с&nbsp;кнопкой, отправляющиеся клиенту в&nbsp;боте при завершении записи.
            </p>

            <p>По-умолчанию уведомление не&nbsp;активно.</p>

            <p>После настройки нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-13.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Отмена записи менеджером&raquo; можно управлять активностью и&nbsp;изменить текст
              автоматического сообщения с&nbsp;кнопкой, отправляющиеся клиенту в&nbsp;боте при отмене записи менеджером.
            </p>

            <p>По-умолчанию уведомление активно.</p>

            <p>После настройки нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-14.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Напоминание о&nbsp;записи&raquo; можно управлять активностью, настроить и&nbsp;изменить
              текст автоматического сообщения с&nbsp;кнопкой, отправляющиеся клиенту в&nbsp;боте за&nbsp;выбранное время
              до&nbsp;начала записи.
            </p>

            <p>По-умолчанию уведомление активно.</p>

            <p>После настройки нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-15.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Изменения в&nbsp;записи&raquo; можно управлять активностью и&nbsp;изменить текст
              автоматического сообщения с&nbsp;кнопкой, отправляющиеся клиенту в&nbsp;боте при внесении менеджером
              изменений в&nbsp;запись.
            </p>

            <p>По-умолчанию уведомление активно.</p>

            <p>После настройки нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-16.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="uslugi-s-zayavkami"
            class="typography__headline2"
          >
            Услуги с заявками
          </FaqArticlesBlockHeading>

          <p>В&nbsp;меню слева выберите раздел &laquo;Услуги с&nbsp;заявками&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-17.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Новая заявка&raquo; можно управлять активностью и&nbsp;изменить текст автоматического
              сообщения с&nbsp;кнопкой, отправляющиеся клиенту в&nbsp;боте при оформлении новой заявки.
            </p>

            <p>По-умолчанию уведомление активно.</p>

            <p>После настройки нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-18.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Завершение заявки&raquo; можно управлять активностью и&nbsp;изменить текст автоматического
              сообщения с&nbsp;кнопкой, отправляющиеся клиенту в&nbsp;боте при завершении заявки.
            </p>

            <p>По-умолчанию уведомление не&nbsp;активно.</p>

            <p>После настройки нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/uvedomleniya-klienta-19.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Как настроить уведомления клиента разобрались. Самое время перейти к&nbsp;<BaseLink
              class="ui-link-secondary"
              to="/faq/articles/bot-dlya-klientov"
              >изучению бота для клиентов
            </BaseLink>
            .
          </p>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Бот и&nbsp;интеграции",
    url: "/faq/categories/bot-i-integratsii",
  },
  {
    name: "Уведомления клиента",
  },
];

const menu = [
  {
    name: "Как&nbsp;попасть",
    url: "kak-popast",
  },
  {
    name: "Товары",
    url: "tovary",
  },
  {
    name: "Услуги&nbsp;с&nbsp;онлайн-записью",
    url: "uslugi-s-onlayn-zapisyu",
  },
  {
    name: "Услуги&nbsp;с&nbsp;заявками",
    url: "uslugi-s-zayavkami",
  },
];

const relatedArticles = [
  {
    name: "Бот для клиентов",
    slug: "bot-dlya-klientov",
  },
  {
    name: "Конструктор бота",
    slug: "konstruktor-bota",
  },
  {
    name: "Подключение к&nbsp;Telegram",
    slug: "podklyuchenie-k-telegram",
  },
];

useSeoMeta({
  title: "Уведомления клиента",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
